import { ReactNode } from "react";
import { IconContext } from "react-icons";

export const IconsProvider = ({ children }: { children: ReactNode }) => (
  <IconContext.Provider value={{ style: { fontSize: "inherit" } }}>
    {children}
  </IconContext.Provider>
);
